import { Images } from 'constants'
import { UserContext } from 'context';
import { verifyLogin } from 'features';
import React, { useContext, useState } from 'react'
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';

const Verify = () => {
    const getAdminData = JSON.parse(localStorage.getItem('AdminData'));
    // console.log('first', getAdminData);


    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setToken } = useContext(UserContext);

    const handleChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < 5) {
                const next = document.getElementById(`otp-${index + 1}`);
                if (next) next.focus();
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const enteredOtp = otp.join("");

        if (enteredOtp.length !== 6) {
            toast.error("Please enter a valid 6-digit OTP.");
            return;
        }

        const userData = JSON.parse(localStorage.getItem("AdminData"));

        try {
            const res = await dispatch(
                verifyLogin({
                    ...userData,
                    otp: enteredOtp,
                })
            );

            const responseData = res?.payload;
            console.log("responseData?.data?.user", responseData?.data?.user)

            if (responseData?.status === 1) {
                StorageServices.setToken(responseData?.data?.user?.token);
                StorageServices.setLocalItem('userData', JSON.stringify(responseData?.data?.user));
                toast.success("OTP Verified Successfully!");
                navigate("/user");
            } else {
                toast.error(responseData?.message || "Invalid OTP");
            }
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong. Please try again.");
        }
    };



    return (
        <div className="_midOb_bx">
            <div className="_innrMid_bx">
                <img className="_logoOn_board" src={Images.LOGO} alt="" />

                <div className="_midOd_head">
                    <h3>Verify Mobile Number</h3>
                    <p>
                        Enter 6 digit code has been sent to: <br />
                        <span className="_numberOtp" >
                            {" "}
                            +91 {getAdminData?.phoneNumber}
                            {/* {data && data.data && data.data.mobile_no} */}

                        </span>
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="_subFrm_fx">
                        <div className="_baseInput_bx">
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: '5px' }}>
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`otp-${index}`}
                                        type="text"
                                        maxLength={1}
                                        inputMode="numeric"
                                        className="__mobPin_input"
                                        value={digit}
                                        onChange={(e) => handleChange(e.target.value, index)}
                                    />
                                ))}
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="anime-btn _submitOn_board"
                        >
                            Verify OTP
                        </button>
                    </div>
                </form>



                {/* <form onSubmit={handleSubmit}>
              <div className="_subFrm_fx">
                <div className=" mt-4">
                  <CommonInput
                    // placeholder="Phone"
                    label="Phone"
                    labelRedStar={true}
                    type="tel"
                    maxLength={10}
                    name="username"
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    value={form?.phoneNumber}
                    focus={formError?.phoneNumber}
                    error={formError?.phoneNumber}
                  />
                </div>
                <div className="">
                  <CommonInput
                    type="password"
                    label="Password"
                    labelRedStar={true}
                    name="password"
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    value={form?.password}
                    focus={formError?.password}
                    error={formError?.password}
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="anime-btn _submitOn_board"
                >
                  {loading ? "Verifing.." : "Login"}{" "}
                </button>
              </div>
            </form> */}
            </div>
        </div>
    )
}

export default Verify